import axios from 'axios';

import accessLocalStorage from './accessLocalStorage';

export const chartEndpointsReceiveds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`http://${ipClean}/relatorio/receiveds/endpoints`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const chartHoursReceiveds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`http://${ipClean}/relatorio/receiveds/hours`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const chartSectorsReceiveds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`http://${ipClean}/relatorio/receiveds/sectors`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const chartDaysReceiveds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`http://${ipClean}/relatorio/receiveds/days`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const chartResumeReceiveds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`http://${ipClean}/relatorio/receiveds/resume`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const chartEndpointsSendeds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`http://${ipClean}/relatorio/sendeds/endpoints`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const chartHoursSendeds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`http://${ipClean}/relatorio/sendeds/hours`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const chartSectorsSendeds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`http://${ipClean}/relatorio/sendeds/sectors`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const chartDaysSendeds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`http://${ipClean}/relatorio/sendeds/days`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const chartResumeSendeds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`http://${ipClean}/relatorio/sendeds/resume`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const logsReport = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;

  try {
    const response = await axios
      .post(`http://${ipClean}/relatorio/logs`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const chartResumeInternals = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`http://${ipClean}/relatorio/internals/resume`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const createTenant = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  try {
    const response = await axios
      .post(`http://${ipClean}/api/tenants/create`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const readAllTenant = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios.get(`http://${ipClean}/api/tenants`,  { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const listFilesUploaded = async (dataRequest) => {
  const { token, ipRequest, user: { idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios.post(`http://${ipClean}/api/uploads/list`, { tenant: idtenant }, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const downloadFileTenants = async (dataRequest) => {
  const { token, ipRequest, user: { idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios.post(`http://${ipClean}/api/uploads/download`, dataRequest, { headers: { Authorization: token }, responseType: 'blob' });
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteFileTenant = async (dataRequest) => {
  const { token, ipRequest, user: { idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios.post(`http://${ipClean}/api/uploads/delete`, dataRequest, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const playFileTenant = async (dataRequest) => {
  const { token, ipRequest, user: { idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const { tenant, folder, fileName } = dataRequest;
    return `http://${ipClean}/api/uploads/play?tenant=${tenant}&type=${folder}&fileName=${fileName}`;
  } catch (error) {
    return error;
  }
};
